/* eslint-disable no-useless-escape */

import { ITERABLE_TOKEN, ITERABLE_URL } from 'utils/constants/iterable';
import { isValidEmail } from 'utils/formHelpers';
import { showFlash } from 'utils/domHelpers';

const subscribe = (email: string) => {
  const iterableURL = ITERABLE_URL;
  const analyticsAuth = `Basic ${ITERABLE_TOKEN}`;

  // Iterable Metadata
  const syncData = {
    emailData: {
      email,
      newEmail: email,
    },
    eventData: {
      dataFields: {
        emailCollectionResults: email,
      },
      email,
      eventName: 'emailCollectionResults',
    },
    eventType: 'EmailCollectionResults',
  };

  // Submit email to iterable
  fetch(`${iterableURL}/sync-event`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: analyticsAuth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(syncData),
  })
    .then(() => showFlash('alert-success', 'Thanks for subscribing!'))
    .catch(() =>
      showFlash(
        'alert-error',
        'Unable to subscribe, please try an alternate email.',
      ),
    );
};

const handleIterableSubscription = (email: string) => {
  if (isValidEmail(email)) {
    return subscribe(email);
  }
  return showFlash('alert-error', 'Please enter a valid email.');
};

export { handleIterableSubscription, subscribe };
